// Generic filter DTO builder for backend API
// Converts filters object and filterConfig into an array of { field, value, operation }

import { FilterOperation, FilterType } from "@/types/filter";

export interface BackendFilter {
  operation: string;
  value: any;
  type: string;
}
export interface BackendSort {
  key: string;
  direction: 'asc' | 'desc';
}
export interface FilterDto {
  filters: Record<string, BackendFilter>;
  sort: BackendSort[];
  pagination: { page: number; pageSize: number };
}

// Generic filter DTO builder for backend API (object, not array)
export function buildFilterDto({
  filters,
  sortKey,
  sortDirection,
  page,
  pageSize,
  filterConfig
}: {
  filters: Record<string, any>;
  sortKey?: string;
  sortDirection?: 'asc' | 'desc';
  page: number;
  pageSize: number;
  filterConfig?: Array<{ key: string; type: string }>;
}): FilterDto {
  const backendFilters: Record<string, BackendFilter> = {};
  if (filters && filterConfig) {
    filterConfig.forEach(f => {
      const value = filters[f.key];
      if (value !== undefined && value !== null && value !== '') {
        if (f.type === 'select') {
          // Use filterType if present, else default to STRING
          const filterType = (f as any).filterType || FilterType.STRING;
          backendFilters[f.key] = { operation: FilterOperation.EQUAL, value, type: filterType };
        } else if (f.type === 'text') {
          backendFilters[f.key] = { operation: FilterOperation.CONTAINS, value, type: FilterType.STRING };
        }
      }
    });
  }
  let sort: BackendSort[] = [];
  if (sortKey) {
    sort = [{ key: sortKey, direction: sortDirection || 'asc' }];
  }
  return {
    filters: backendFilters,
    sort,
    pagination: { page, pageSize },
  };

}
